module.exports = __webpack_public_path__ + "static/legend_example-b651b3d1cc4772889f6199e1aa8ca997.png";